angular.module('impactx.login').controller('LotOutletsCtrl', LotOutletsCtrl);

LotOutletsCtrl.$inject = ['$scope', 'outlets', 'outletsInfo', 'contractsInfo', 'outletsHeader', 'outletsInfoHeader', 'conditionsHeader', 'cancelHeader', 'header', 'cancelConditionsHeader', 'cancelSingleConditionHeader'];

function LotOutletsCtrl($scope, outlets, outletsInfo, contractsInfo, outletsHeader, outletsInfoHeader, conditionsHeader, cancelHeader, header, cancelConditionsHeader, cancelSingleConditionHeader) {
    $scope.outlets = outlets;
    $scope.outletsInfo = outletsInfo;
    $scope.contractsInfo = contractsInfo;
    $scope.outletsHeader = outletsHeader;
    $scope.outletsInfoHeader = outletsInfoHeader;
    $scope.conditionsHeader = conditionsHeader;
    $scope.cancelHeader = cancelHeader;
    $scope.header = header;
    $scope.cancelConditionsHeader = cancelConditionsHeader;
    $scope.cancelSingleConditionHeader = cancelSingleConditionHeader;
}